import { DAYTOOL } from "../classes/daytool.js";
import { daytool_need } from "../classes/daytool_entity.js";
import { daytool_injector } from "../classes/UI/daytool_injector.js";

export function loadFunBasicPresets() {
  // FUN
  var fun = new daytool_need();
  fun.title.push("Fun");
  fun.icon.push("fun");
  fun.imported = true;
  fun.description.push("Set aside time to enjoy the things you love.");
  DAYTOOL.addEntity(fun);
  // FUN GOAL SUGGESTIONS
  // 1. Learn more about your personal tastes
  // 2. Time to explore and be curious
  // 3. Playing favorite games more often
  // 4. Going to favorite places
  // 5. Vacations, holidays and breaks
  // 6. Learning new skills
  // 7. Learning about the world: history, location, science, literature
}
